<template>
    <div class="insights-card-holder">
        <AonCard
            v-for="insight in insights"
            class="insights-card p-xs mb-xs"
            :key="insight.id"
            :remove-padding="['t', 'r', 'b', 'l']"
        >
            <div class="insight-row display-flex justify-between">
                <div class="wrap display-flex">
                    <font-awesome-icon
                        icon="fas fa-lightbulb-on"
                        class="mr-xs color-warning-hover"
                        style="margin-top: 2px"
                    />
                    <p class="insight-type mr-xs">
                        <span class="font-bold"
                            >{{ t(`insights.types.${insight.insightType}`) }}:</span
                        >
                        {{ insight.insightText }}
                    </p>
                </div>
                <p
                    style="min-width: 80px"
                    class="learn-more-link link text-sm cursor-pointer"
                    @click="learnMoreClick(insight.insightType)"
                >
                    Learn More
                </p>
            </div>
        </AonCard>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useEntityStore } from '@/stores'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const entityStore = useEntityStore()
const insights = ref([])
const { t } = useI18n()
const router = useRouter()

const props = defineProps({
    insightTypes: {
        type: Array,
        required: true,
        default: () => [],
    },
})

onMounted(async () => {
    const response = await entityStore.onGetInsights(
        entityStore.entity.aon_entity_pk,
        props.insightTypes
    )
    insights.value = response
})

const learnMoreClick = (insightType) => {
    if (['key_inventor_left', 'key_inventor_joined'].includes(insightType)) {
        gotoInventorsTab()
    } else if (insightType === 'litigation_risk') {
        gotoRiskTab()
    } else {
        gotoProductTab()
    }
}

const gotoProductTab = () => {
    router.push({
        name: 'Research Company',
        params: { targetPk: entityStore.entity.aon_entity_pk },
        query: { tabName: 'moat2Product' },
    })
}

const gotoInventorsTab = () => {
    router.push({
        name: 'Research Company',
        params: { targetPk: entityStore.entity.aon_entity_pk },
        query: { tabName: 'execution' },
    })
}

const gotoRiskTab = () => {
    router.push({
        name: 'Research Company',
        params: { targetPk: entityStore.entity.aon_entity_pk },
        query: { tabName: 'risk' },
    })
}
</script>

<style lang="scss" scoped>
.insights-card-holder {
    width: 100%;
}

.insights-card {
    &:last-of-type {
        margin-bottom: 0 !important;
    }
    &.a-card {
        background: var(--color-warning-bg);
    }
    .color-warning-hover {
        color: var(--color-warning-hover) !important;
    }
}
</style>
